//Modules
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';


//Components and Styles
import './ProjectCard.css';
import { useHeroImage } from './HeroImageContext';

//Component
export const ProjectCard = ({ className, title, subtitle, number, description, imageUrl, path, onNavigate, index, isLoaded}) => {
  const cardRef = useRef(null);
  const { setHeroImage, defaultHeroImage, resetHero } = useHeroImage();

  useEffect(() => {
    const currentCardRef = cardRef.current;
    
    // Animation
    const handleMouseEnter = () => {
      setHeroImage(imageUrl, {
        caption: number,
        title: subtitle,
        description: description,
      });
    };

    const handleMouseLeave = () => {
      resetHero();
    };

  
    if (currentCardRef) {
      currentCardRef.addEventListener('mouseenter', handleMouseEnter);
      currentCardRef.addEventListener('mouseleave', handleMouseLeave);
    }
  
    return () => {
      if (currentCardRef) {
        currentCardRef.removeEventListener('mouseenter', handleMouseEnter);
        currentCardRef.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [imageUrl, setHeroImage, defaultHeroImage, resetHero, subtitle, description, number]);

  useEffect(() => {
    if (!isLoaded) return;
    if (!cardRef.current) return;

    gsap.fromTo(
      cardRef.current,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        delay: 1 + index * 0.1,
      }
    );
  }, [isLoaded, index]);

  //Render
  return (
    <Link 
      className={`project-card ${className}`} 
      ref={cardRef} 
      to={path} 
      onClick={(e) => {
        e.preventDefault();
        if (onNavigate) onNavigate(path);
      }}
    >
      <div className="card-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 36 36" fill="none">
          <path d="M10.2215 25.0711L24.3636 10.9289M24.3636 10.9289H10.2215M24.3636 10.9289V25.0711" stroke="#2D2D2D" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="left-section">
        <div className="subtitle card-title"> {title} </div>
      </div>
    </Link>
  );
};
